import { render, staticRenderFns } from "./userPhysicalInfo.vue?vue&type=template&id=4cfed516&scoped=true"
import script from "./userPhysicalInfo.vue?vue&type=script&lang=js"
export * from "./userPhysicalInfo.vue?vue&type=script&lang=js"
import style0 from "./userPhysicalInfo.vue?vue&type=style&index=0&id=4cfed516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfed516",
  null
  
)

export default component.exports